export default function makeForeignKey
    //generics
    <
        T extends Record<string, any>,
        TCollectionKey extends keyof T,
        TCollectionItem extends NonNullable<(T[TCollectionKey] extends (infer U)[]
            ? U
            : NonNullable<T[TCollectionKey]> extends object
                ? T[TCollectionKey]
                : never)>,
        TForeignKey extends keyof TCollectionItem
    >
    // arguments
    (
        source: T[],
        collectionKey: TCollectionKey,
        foreignKey: TForeignKey
    ):
    // return tuple
    [
        Array<Pick<T, Exclude<keyof T, TCollectionKey>>
              & Record<TCollectionKey, T[TCollectionKey] extends any[] ? TCollectionItem[TForeignKey][] : TCollectionItem[TForeignKey]>>,
        TCollectionItem[]
    ]
{
    return source.reduce((result: any, item: T) => {
        if (item == null || item[collectionKey] == null) {
            result[0] = result[0].concat(item);
            return result;
        }

        const foreignItems : TCollectionItem | TCollectionItem[] = item[collectionKey];

        result[0] = result[0].concat({
            ...item,
            [collectionKey]: foreignItems instanceof Array
                ? foreignItems.map((foreignItem: TCollectionItem) => foreignItem[foreignKey])
                : foreignItems[foreignKey]
        });
        result[1] = result[1].concat(foreignItems);

        return result;
    }, [[], []]);
}